var jquery = require("jquery");
window.$ = window.jQuery = jquery;
require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;
import ScrollOut from "scroll-out";

ScrollOut({
	cssProps: {
		viewportY: true,
	},
});


var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.headerContainer').outerHeight();

// READY

$(function () {

	console.log('Website proudly by Imagic Creative');

	$("[data-required]").each(function (index) {
		$(this).attr('required', true);
	});



	setInterval(function() {
        adjustIframeHeight();
    }, 250);


	setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);


	setInterval(function() {
		if (window.location.hash) {
			// Extract the section number from the hash
			var sectionNumber = window.location.hash.substring(9); // Assuming #section-XXX format
			var section = $('[data-ni-block-id="' + sectionNumber + '"]');
			if (section.length) {
				$('html, body').animate({
					scrollTop: $('[data-ni-block-id="' + sectionNumber + '"]').offset().top
				}, 'slow');
			}

			// Remove the hash from the URL after scrolling
			history.replaceState({}, document.title, window.location.pathname);
			$('header').removeClass('nav-up').removeClass('nav-down');
		}
	}, 250);

	ticker();

});


// SCROLL

$(window).on('scroll', function(e) {

	didScroll = true;

	var scrollTop = $(window).scrollTop();

	ticker();

});


// RESIZE

$(window).on('resize', function() {
	
	adjustIframeHeight();

	if ($('.accordion.is-open').length) {
		$('.accordion.is-open').each(function() {
			var content = $(this).parent().find('.accordion-content');

			var maxH = 0;
			content.find('> div').each(function() {
				var divHeight = $(this).outerHeight();
				if ($(window).width() < 1024) {
					maxH += divHeight;
				} else {
					if (divHeight > maxH) {
						maxH = divHeight;
					}
				}
			});

			maxH += 40;

			content.css('max-height', maxH);
		})
	}

});




// IFRAME


function adjustIframeHeight() {
	var iframe = $('iframe.form');
	var iframeHeight = iframe.contents().find('html').height() + 150;
	iframe.height(iframeHeight);
}
// Adjust iframe height when its content changes (assuming the content is on the same domain)
$('iframe.form').on('load', function() {
	adjustIframeHeight();
});


// ACCORDION
$(document).on('click', '.accordion:not(.is-open)', function(e) {
	// $(this).parent().parent().find('.accordion.is-open').trigger('click');
	$(this).addClass('is-open');
	var content = $(this).parent().find('.accordion-content');

	var maxH = 0;
    content.find('> div').each(function() {
        var divHeight = $(this).outerHeight();
		if ($(window).width() < 1024) {
			maxH += divHeight;
		} else {
			if (divHeight > maxH) {
				maxH = divHeight;
			}
		}
    });

	maxH += 40;

	content.css('max-height', maxH);
});
$(document).on('click', '.accordion.is-open', function(e) {
	$(this).removeClass('is-open');
	var content = $(this).parent().find('.accordion-content');
	content.removeAttr('style');
});





// MENU HOVER

$('header .column-menu .menu-parent').on('mouseover', function() {
	if (isTouchDevice()) {
		return false;
	}
	var target = $(this).attr('data-target');
	$('header .column-menu .menu-parent').removeClass('active');
	$(this).addClass('active');
	var dropdowns = $('.header-dropdown[data-dropdown]')
	var dropdown = $('.header-dropdown[data-dropdown="' + target + '"]')
	dropdowns.attr('data-expanded', false);
	dropdown.attr('data-expanded', true);
});
$('body').on('mouseover', function(event) {
	if (isTouchDevice()) {
		return false;
	}
    if (
		!$(event.target).hasClass('menu-parent') && 
		!$(event.target).hasClass('header-menu') && 
		!$(event.target).parent().hasClass('menu-parent') && 
		!$(event.target).closest('.header-dropdown').length && 
		!$(event.target).hasClass('header-dropdown') || 
		$(event.target).closest('section').length
	) {
		// console.log($(event.target))
		// console.log($(event.target).hasClass('header-dropdown'))
		$('header .column-menu .menu-parent').removeClass('active');
		var dropdowns = $('.header-dropdown[data-dropdown]')
		dropdowns.attr('data-expanded', false);
    }
});

// MENU TOUCH DESKTOP

$('header .column-menu .menu-parent .menu-parent-icon').on('click', function() {
	if (!isTouchDevice()) {
		return false;
	}
	var dropdowns = $('.header-dropdown[data-dropdown]')
	if ($(this).hasClass('active')) {
		$('header .column-menu .menu-parent .menu-parent-icon').removeClass('active');
		$('header .column-menu .menu-parent').removeClass('active');
		dropdowns.attr('data-expanded', false);
	} else {
		var target = $(this).parent().attr('data-target');
		$('header .column-menu .menu-parent').removeClass('active');
		$(this).parent().addClass('active');
		$('header .column-menu .menu-parent .menu-parent-icon').removeClass('active');
		$(this).addClass('active');
		var dropdown = $('.header-dropdown[data-dropdown="' + target + '"]')
		dropdowns.attr('data-expanded', false);
		dropdown.attr('data-expanded', true);
	}
});

// MENU TOUCH MOBILE

$('aside .menu-parent-icon').on('click', function() {
	var dropdowns = $('.menu-dropdown[data-dropdown]')
	if ($(this).hasClass('active')) {
		$('aside .menu-parent-icon').removeClass('active');
		$('aside .menu-parent').removeClass('active');
		dropdowns.attr('data-expanded', false);
		dropdowns.each( function() {
			$(this).slideUp();
		});
	} else {
		var target = $(this).parent().attr('data-target');
		$('aside .menu-parent').removeClass('active');
		$(this).parent().addClass('active');
		$('aside .menu-parent-icon').removeClass('active');
		$(this).addClass('active');
		var dropdown = $('.menu-dropdown[data-dropdown="' + target + '"]')
		dropdowns.attr('data-expanded', false);
		dropdowns.each( function() {
			$(this).slideUp();
		});
		dropdown.attr('data-expanded', true);
		dropdown.slideDown();
	}
});
$('[data-menu-trigger]').on("click", function(e) {
	e.stopPropagation();
	$(this).find('.hamburger').toggleClass('open');
	$('body').toggleClass('mobile-menu-open');
	$('aside.mobile-menu').slideToggle();
	if ($(window).scrollTop() > 0) {
		$('header').addClass('nav-down');
	}
});


function hasScrolled() {
	
	if ($('body.mobile-menu-open').length) {
		return;
	}

	if ($('footer[data-scroll="in"]').length && $(window).width() < 1024) {
		$('header').removeClass('nav-up').addClass('nav-down');
		return;
	}
		
    var st = $(window).scrollTop();
    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.

    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        if ($('header').hasClass('nav-down')) {
            $('header').removeClass('nav-down').addClass('nav-up');
        }
    } else {
        // Scroll Up
        if(st > navbarHeight && (st + $(window).height() < $(document).height())) {
            $('header').removeClass('nav-up').addClass('nav-down');
        } 
        
        if(st < 5) {
            $('header').removeClass('nav-up').removeClass('nav-down');
        }
    }

    
    lastScrollTop = st;
} 


function isTouchDevice() {
	return (('ontouchstart' in window) ||
	   (navigator.maxTouchPoints > 0) ||
	   (navigator.msMaxTouchPoints > 0));
}





// NEWS
$(function () {

	if ($('[data-section="news"]').length) {
		var results = $('[data-section="news"] .article-block.visible').length;
		$('[data-section="news"] .results').html(results + ' result' + (results > 1 || results == 0 ? 's' : ''));
	}

});
$('[data-filter]').on("click", function(e) {
	var cat = $(this).attr('data-filter');
	var categoryURL = getUrlParameter('category');
	if (categoryURL) {
		var category = unique(categoryURL.split(',').filter(item => item)) ?? false;
	} else {
		var category = [];
	}

	var cards = $('[data-section="news"] .article-block');
	cards.removeClass('visible');
	cards.fadeOut();
	var currentUrl = window.location.href;
	currentUrl = decodeURIComponent(currentUrl);
	var url = new URL(currentUrl);

	$('[data-filter-all]').removeClass('active');

	if ($(this).hasClass('active')) {
		if(jQuery.inArray(cat, category) !== -1) {
			var index = $.inArray(cat, category);
			category.splice(index, 1)
		}
		$(this).removeClass('active');
	} else {
		if(jQuery.inArray(cat, category) === -1) {
			category.push(cat)
		}
		$(this).addClass('active');
	}

	url.searchParams.set('category', category.join(','));
	window.history.replaceState({}, document.title, url.toString());
	
	if (category.length) {
		var i;
		for (i = 0; i < category.length; ++i) {
			$('[data-section="news"] .article-block.category-' + category[i]).addClass('visible');
			$('[data-section="news"] .article-block.category-' + category[i]).fadeIn();
		}
	} else {
		$('[data-filter-all]').trigger('click');
	}

	var results = $('[data-section="news"] .article-block.visible').length;
	$('[data-section="news"] .results').html(results + ' result' + (results > 1 ? 's' : ''));
	// console.log($('[data-section="news"] .article-block:visible').length)

});

$('[data-filter-all]').on("click", function(e) {
	if ($(this).hasClass('active')) {
		return false;
	}
	
	var cards = $('[data-section="news"] .article-block');
	cards.fadeOut();
	cards.removeClass('visible');
	var currentUrl = window.location.href;
	currentUrl = decodeURIComponent(currentUrl);
	var url = new URL(currentUrl);
	url.searchParams.set('category', '');
	window.history.replaceState({}, document.title, url.toString());

	$('[data-filter-all]').addClass('active');
	$('[data-filter]').removeClass('active');

	setTimeout(() => {
		cards.fadeIn();
		cards.addClass('visible');
		var results = $('[data-section="news"] .article-block.visible').length;
		$('[data-section="news"] .results').html(results + ' result' + (results > 1 ? 's' : ''));
	}, 300);
	
});


var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

function unique(list) {
    var result = [];
    $.each(list, function(i, e) {
        if ($.inArray(e, result) == -1) result.push(e);
    });
    return result;
}




// NUMBER TICKER
var tickerTriggered = false;

function ticker() {
    if (!tickerTriggered) {
        var numberDiv = $('[data-section="textType4"] .number .value');
		if (!numberDiv.length) {
			return false;
		}
        var inView = isElementInViewport(numberDiv[0]); // Check if the element is in view
        if (inView) {
            numberDiv.each(function () {
                var currentValue = $(this).text().replace(/,/g, ''); // Remove commas before parsing
                var targetValue = parseFloat(currentValue);
                $(this).prop('Counter', 0).animate({
                    Counter: targetValue
                }, {
                    duration: 1500,
                    easing: 'swing',
                    step: function (now) {
                        $(this).text(addCommas(Math.ceil(now))); // Add commas back after rounding
                    }
                });
            });
            tickerTriggered = true; // Set the flag to true after triggering the animation
        }
    }
}

// Function to check if an element is in the viewport
function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

// Function to add commas to numbers
function addCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}



// Accordion
if ($('.row-accordion').length) {
	$('.row-accordion').each(function() {
		var $instance = $(this);
		var $blocks = $instance.find('.accordion-block');
		$blocks.click(function() {
			var $desc = $(this).find('.description');
			$desc.stop().slideToggle();
		})
	})
}


// Calculator
const mainSection = $('[data-section="calculator"]');
const resultSection = $('[data-section="calculator-result"]');

$(document).on('click', '[data-section="calculator-result"] .column-button .btn', function(e) {
    location.reload();
});

var data = {};

window.calculator = function calculator(submissionId, targetRevenue) {
    // Fetch CSRF token from JSON endpoint
    $.getJSON('/actions/blitz/csrf/json', function(response) {
        var csrfTokenValue = response.token;
        console.log('*** CALCULATOR ***');
        data['CRAFT_CSRF_TOKEN'] = csrfTokenValue;
        data['submissionId'] = submissionId;
        data['targetRevenue'] = targetRevenue;
        $.ajax({
            type: 'post',
            url: '/actions/calculator/calculator/result',
            data: data,
            success: function(response) {
                console.log(response);
                var success = response.success;
                if (success) {
					if (resultSection.length) {
                    	resultSection.find('.total-cost').text(response.totalCost);
                    	resultSection.find('.required-hours').text(response.requiredHours + ' hours');
					}
                    if (mainSection.length) {
						mainSection.hide();
					}
					if (resultSection.length) {
                    	resultSection.show();
					}
                } else {
                    console.log('Calculator error');
                }
            },
            error: function(response) {
                console.log(response);
            }
        });

    });
}

window.addEventListener('message', function(event) {
	if (event.origin !== 'https://go.janiking.co.nz') {
		console.error("Calculator error: wrong event.origin " + event.origin);
		return;
	}

	const { type, submissionId, targetRevenue } = event.data;

	if (type === 'calculator') {
		if (submissionId && targetRevenue) {
			calculator(submissionId, targetRevenue);
		} else {
			console.error('Calculator error: missing calculator parameters');
		}
	}
});
// $(function () {
// window.parent.postMessage({type: 'calculator',submissionId: 123,targetRevenue: 15000}, 'https://jk23.ddev.site');
// });